import { primitiveColors, semanticColors } from "@dfp/isomorphic-design-tokens";

declare module "@mui/material/styles" {
  interface Palette {
    brand: {
      fill: string;
      icon: string;
    };
    custom: {
      fillSecondary: string;
      fillSecondaryHover: string;
      fillTertiaryHover: string;
      fillHover: string;
      fillInverse: string;
      fillActive: string;
      surfaceTertiary: string;
      borderSecondarySuccess: string;
      borderSecondaryWarning: string;
      borderSecondaryError: string;
      borderSecondaryInfo: string;
      borderAccent: string;
      border: string;
      borderHover: string;
      borderPrimary: string;
      borderDisabled: string;
      borderError: string;
      bgInverse: string;
      icon: string;
      iconSuccess: string;
      iconWarning: string;
      iconError: string;
      iconInfo: string;
      fillNeutral: string;
      backdrop: string;
      iconAccent: string;
    };
  }

  interface PaletteOptions {
    brand?: {
      fill?: string;
      icon?: string;
    };
    custom?: {
      fillNeutral?: string;
      fillSecondaryHover?: string;
      fillTertiaryHover?: string;
      fillHover?: string;
      fillInverse?: string;
      fillSecondary?: string;
      fillActive?: string;
      surfaceTertiary?: string;
      borderSecondarySuccess?: string;
      borderSecondaryWarning?: string;
      borderSecondaryError?: string;
      borderSecondaryInfo?: string;
      borderAccent?: string;
      border?: string;
      borderHover?: string;
      borderPrimary?: string;
      borderDisabled?: string;
      borderError?: string;
      bgInverse?: string;
      icon?: string;
      iconSuccess?: string;
      iconWarning?: string;
      iconError?: string;
      iconInfo?: string;
      backdrop?: string;
      iconAccent?: string;
    };
  }
}

export const palette = {
  common: {
    white: primitiveColors.greyscale.white,
    black: primitiveColors.greyscale.black,
  },
  primary: {
    light: semanticColors.textSecondary,
    main: semanticColors.fill,
    contrastText: semanticColors.textInverse,
  },
  secondary: {
    light: semanticColors.fillNeutralHover,
    main: semanticColors.surfaceSecondary,
    dark: semanticColors.surfaceSecondary,
    contrastText: semanticColors.text,
  },
  accent: {
    light: semanticColors.surfaceAccent,
    main: semanticColors.fillAccent,
    dark: semanticColors.fillAccent,
    contrastText: semanticColors.textInverse,
  },
  error: {
    light: semanticColors.surfaceError,
    main: semanticColors.fillError,
    dark: semanticColors.fillErrorHover,
    contrastText: semanticColors.textInverse,
  },
  errorSecondary: {
    light: semanticColors.surfaceError,
    main: semanticColors.fillErrorSecondary,
    dark: semanticColors.fillErrorSecondaryHover,
    contrastText: semanticColors.textError,
  },
  success: {
    light: semanticColors.surfaceSuccess,
    main: semanticColors.fillSuccess,
    dark: semanticColors.fillSuccess,
    contrastText: semanticColors.textSuccess,
  },
  warning: {
    light: semanticColors.surfaceWarning,
    main: semanticColors.fillWarning,
    dark: semanticColors.fillWarning,
    contrastText: semanticColors.textWarning,
  },
  info: {
    light: semanticColors.surfaceInfo,
    main: semanticColors.fillInfo,
    dark: semanticColors.fillInfo,
    contrastText: semanticColors.textInfo,
  },
  grey: {
    25: primitiveColors.greyscale[25],
    50: primitiveColors.greyscale[50],
    100: primitiveColors.greyscale[100],
    200: primitiveColors.greyscale[200],
    300: primitiveColors.greyscale[300],
    400: primitiveColors.greyscale[400],
    500: primitiveColors.greyscale[500],
    600: primitiveColors.greyscale[600],
    700: primitiveColors.greyscale[700],
    800: primitiveColors.greyscale[800],
    900: primitiveColors.greyscale[900],
  },
  background: {
    main: semanticColors.bg,
    paper: semanticColors.surface,
    accent: semanticColors.surfaceAccent,
  },
  divider: semanticColors.borderSecondary,
  text: {
    main: semanticColors.text,
    primary: semanticColors.text,
    secondary: semanticColors.textSecondary,
    disabled: semanticColors.textDisabled,
  },
  action: {
    disabled: semanticColors.textDisabled,
    disabledBackground: semanticColors.fillDisabled,
  },
  brand: {
    fill: semanticColors.fillBrand,
    icon: semanticColors.iconBrand,
  },
  custom: {
    fillNeutral: semanticColors.fillNeutral,
    fillSecondary: semanticColors.fillSecondary,
    fillSecondaryHover: semanticColors.fillSecondaryHover,
    fillTertiaryHover: semanticColors.fillTertiaryHover,
    fillHover: semanticColors.fillHover,
    fillInverse: semanticColors.fillInverse,
    fillActive: semanticColors.fillActive,
    surfaceTertiary: semanticColors.surfaceTertiary,
    iconInfo: semanticColors.iconInfo,
    borderSecondarySuccess: semanticColors.borderSecondarySuccess,
    borderSecondaryWarning: semanticColors.borderSecondaryWarning,
    borderSecondaryError: semanticColors.borderSecondaryError,
    borderSecondaryInfo: semanticColors.borderSecondaryInfo,
    borderAccent: semanticColors.borderAccent,
    border: semanticColors.border,
    borderHover: semanticColors.borderHover,
    borderPrimary: semanticColors.borderPrimary,
    borderDisabled: semanticColors.borderDisabled,
    borderError: semanticColors.borderError,
    bgInverse: semanticColors.bgInverse,
    icon: semanticColors.icon,
    iconSuccess: semanticColors.iconSuccess,
    iconWarning: semanticColors.iconWarning,
    iconError: semanticColors.iconError,
    iconAccent: semanticColors.iconAccent,
    backdrop: semanticColors.backdrop,
  },
};
